import {
  linkGovernanceAgms,
  linkGovernanceArticlesOfAssociation,
  linkGovernanceAuditcommittee,
  linkGovernanceBoardCharter,
  linkGovernanceCodeOfConduct,
  linkGovernanceCorporateSecretary,
  linkGovernanceInternalAudit,
  linkGovernanceNominationRemuneration,
  linkGovernancePublicExpose,
} from "src/helper/page-url"
import { translations } from "src/helper/translations"

export const governanceList = [
  {
    title_en: "AGMS",
    title_id: "AGMS",
    link: linkGovernanceAgms,
  },
  {
    title_en: translations.public_expose_en,
    title_id: translations.public_expose_id,
    link: linkGovernancePublicExpose,
  },
  {
    title_en: translations.code_of_conduct_en,
    title_id: translations.code_of_conduct_id,
    link: linkGovernanceCodeOfConduct,
  },
  {
    title_en: translations.board_charter_en,
    title_id: translations.board_charter_id,
    link: linkGovernanceBoardCharter,
  },
  {
    title_en: translations.audit_committee_en,
    title_id: translations.audit_committee_id,
    link: linkGovernanceAuditcommittee,
  },
  {
    title_en: translations.nomination_remuneration_en,
    title_id: translations.nomination_remuneration_id,
    link: linkGovernanceNominationRemuneration,
  },
  {
    title_en: translations.internal_audit_en,
    title_id: translations.internal_audit_id,
    link: linkGovernanceInternalAudit,
  },
  {
    title_en: translations.corporate_secretary_en,
    title_id: translations.corporate_secretary_id,
    link: linkGovernanceCorporateSecretary,
  },
  {
    title_en: translations.articles_of_association_en,
    title_id: translations.articles_of_association_id,
    link: linkGovernanceArticlesOfAssociation,
  },
]
